import { LOCALE_CONFIG } from './locales';

export const LANGUAGE_URL_PARAM = 'lang';

// Every spelling a locale can be asked for, upper-cased: its code (ES, ZH-HANS)
// plus its intl, html and Google Translate tags (es, zh-Hans, zh-CN).
const ALIASES = Object.values(LOCALE_CONFIG).reduce((aliases, locale) => {
  [locale.code, locale.intlLocale, locale.htmlLang, locale.googleTarget].forEach(
    (alias) => {
      aliases[alias.toUpperCase()] = locale.code;
    }
  );
  return aliases;
}, {});

const normalize = (value) => value.trim().toUpperCase().replace(/_/g, '-');

// The LOCALE_CONFIG code for a valid ?lang= value, else null. Case is ignored
// and a region suffix falls back to its base language (es-MX -> ES), so an
// unsupported value is left to the caller's normal fallback chain.
export const parseLanguageParam = (search) => {
  const params =
    typeof search === 'string' ? new URLSearchParams(search) : search;
  const value = params.get(LANGUAGE_URL_PARAM);
  if (!value) return null;
  const code = normalize(value);
  return ALIASES[code] || ALIASES[code.split('-')[0]] || null;
};

// The query string without the language param, keeping everything else:
// "?lang=es&zipcode=92101" -> "?zipcode=92101", "?lang=es" -> "".
export const withoutLanguageParam = (search) => {
  const params = new URLSearchParams(search);
  params.delete(LANGUAGE_URL_PARAM);
  const query = params.toString();
  return query ? `?${query}` : '';
};
